"use client";

type RouteStyleProps = {
  css: string;
};

// Next.js keeps visited pages mounted but hidden, so these styles switch off while their page is hidden.
export function RouteStyle({ css }: RouteStyleProps) {
  return (
    <style
      ref={(style) => {
        if (style) style.media = "";
        return () => {
          if (style) style.media = "not all";
        };
      }}
    >
      {css}
    </style>
  );
}
